<template>
	<v-card outlined>
		<v-card-text>
			<p>Paste URL corresponding to LinkedIn article you wish to add.</p>
			<v-layout wrap>
				<v-flex grow pr-4>
					<v-text-field
						label="Linked-In News URL"
						prepend-icon="mdi-linkedin"
						@input="clearTitle"
						v-model="URL"
						filled
					/>
				</v-flex>
				<v-flex shrink>
					<v-btn
						large
						@click="scrape"
						tile
						:color="newsLoaded ? 'secondary' : 'primary'"
						>Fetch</v-btn
					>
				</v-flex>
			</v-layout>

			<template v-if="newsLoaded">
				<v-text-field
					label="Article Title"
					prepend-icon="mdi-format-header-1"
					v-model="title"
					filled
				/>

				<v-btn block large @click="save" tile color="success">
					<v-icon left>mdi-plus</v-icon> Add
				</v-btn>
			</template>
		</v-card-text>
	</v-card>
</template>

<script>
const API_URL = 'https://www.ecc.no/linkedInNews'
import Messages from '@/helpers/message-helper'
import axios from 'axios'

export default {
	name: 'newsScraper',
	data() {
		return {
			URL: '',
			title: '',
		}
	},
	computed: {
		newsLoaded() {
			return this.URL && this.title
		},
	},
	methods: {
		clearTitle() {
			this.title = ''
		},

		async scrape() {
			const params = { URL: this.URL }

			try {
				const result = await axios.get(API_URL, { params })
				const { title, url } = result.data

				if (!title && !url) throw new Error('News article not found')

				this.URL = url
				this.title = title
			} catch (error) {
				console.error(error)
			}
		},

		async save() {
			const { title, URL } = this

			if (title == '' || URL == '') {
				// Message.info({
				// 	title: 'Missing parameter(s)',
				// 	text: 'Title or URL is missing.',
				// })
				return
			}

			this.$emit('save', { title, URL })

			this.URL = ''
			this.title = ''
		},
	},
}
</script>

<style lang="scss" scoped>
</style>